import * as types from '../mutation-types'

// initial state
const state = {
  list: null,
  admin: null
}

// mutations
const mutations = {
  [types.USER_LIST] (state, action) {
    state.list = action.users
    state.admin = action.isAdmin
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js